import { createRouter, createWebHistory } from 'vue-router';
import { routes } from '@/router/routes';
import appConfigs from '@/app/appConfigurations';
import { fakeBackendService } from '@/app/http/httpServiceProvider';
import { useRouter } from 'vue-router';
import { msalInstance, state } from '@/config/msalConfig';
import { msalService } from '@/app/services/serviceProvider';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const title = 'Smart Platform Authentication Application';

router.beforeEach((to, from, next) => {
  // console.log('from>>> ' + JSON.parse(JSON.stringify(from)).fullPath);
  // console.log('to>>> ' + JSON.parse(JSON.stringify(to)).fullPath);
  const auth = appConfigs.auth;
  const router = useRouter();

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title || title;
  }

  const isAuthRequired = to.meta.authRequired;

  if (!isAuthRequired) {
    return next();
  }
  
  if (auth === 'fakebackend') {
    const user = fakeBackendService.getUser();
    const isUserLoggedIn = Object.keys(user).length > 0;

    if (!state.isAuthenticated) {
      state.isAuthenticated = msalInstance.getAllAccounts().length > 0;
    }

    if (isAuthRequired && (isUserLoggedIn || state.isAuthenticated)) {
      next();
    } else {
      router.push('/signin');
    }
  } else {
    next();
  }
});

export default router;
